import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { BreadcrumbMessages } from '../../../models/component-messages/breadcrumb-messages';

@Component({
  selector: 'app-bottom-page',
  templateUrl: './bottom-page.component.html',
  styleUrls: ['./bottom-page.component.scss']
})
export class BottomPageComponent implements OnInit {

  windowScrolled: boolean;
  breadcrumb = new BreadcrumbMessages();

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
      this.windowScrolled = false;
    } else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
      this.windowScrolled = true;
    }
  }

  scrollToBottom() {
      window.scrollTo(0,document.body.scrollHeight);    
      return false;
  }
}
